module.exports = __webpack_public_path__ + "img/cloud-arrow-up.68a8dfe7.svg";